/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PostBulkAdditionMerchantOrgBlockListsRequestInner
 */
export interface PostBulkAdditionMerchantOrgBlockListsRequestInner {
    /**
     * 
     * @type {string}
     * @memberof PostBulkAdditionMerchantOrgBlockListsRequestInner
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof PostBulkAdditionMerchantOrgBlockListsRequestInner
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof PostBulkAdditionMerchantOrgBlockListsRequestInner
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof PostBulkAdditionMerchantOrgBlockListsRequestInner
     */
    'patternType': PostBulkAdditionMerchantOrgBlockListsRequestInnerPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PostBulkAdditionMerchantOrgBlockListsRequestInner
     */
    'storeType': PostBulkAdditionMerchantOrgBlockListsRequestInnerStoreTypeEnum;
}

export const PostBulkAdditionMerchantOrgBlockListsRequestInnerPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type PostBulkAdditionMerchantOrgBlockListsRequestInnerPatternTypeEnum = typeof PostBulkAdditionMerchantOrgBlockListsRequestInnerPatternTypeEnum[keyof typeof PostBulkAdditionMerchantOrgBlockListsRequestInnerPatternTypeEnum];
export const PostBulkAdditionMerchantOrgBlockListsRequestInnerStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type PostBulkAdditionMerchantOrgBlockListsRequestInnerStoreTypeEnum = typeof PostBulkAdditionMerchantOrgBlockListsRequestInnerStoreTypeEnum[keyof typeof PostBulkAdditionMerchantOrgBlockListsRequestInnerStoreTypeEnum];


